"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var EditAndRemoveState_1 = require("./EditAndRemoveState");
var styles = require("./EditAndRemove.scss");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var utils_1 = require("@idp/ui-components/utils");
var components_1 = require("@idp/duc/components");
var UtilityFunctions_1 = require("../../../../utils/UtilityFunctions");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var Button_1 = require("@idp/ui-components/components/atoms/Button/");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
var EditAndRemove = /** @class */ (function (_super) {
    __extends(EditAndRemove, _super);
    function EditAndRemove(props) {
        var _this = _super.call(this, props) || this;
        _this.iconsMode = false;
        _this.isPrepaidExpCart = false;
        _this.hideRemoveLink = false;
        _this.state = new EditAndRemoveState_1.default();
        _this.wirelessCms = wlsUtils.getWlsCmsData();
        _this.editItem = _this.editItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        _this.showDeleteConfirmationModal = _this.showDeleteConfirmationModal.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }
    EditAndRemove.prototype.render = function () {
        this.isPrepaidExpCart = this.props && this.props.options && this.props.options.isPrepaidCart;
        this.iconsMode = this.props && this.props.options &&
            this.props.options.isIconsMode ? this.props.options.isIconsMode : false;
        this.hideRemoveLink = this.props && this.props.options && this.props.options.hideRemoveLink;
        var ariaLabelEdit = this.props.options && this.props.options.ariaLabelEdit || 'Edit line';
        var ariaLabelRemove = this.props.options && this.props.options.ariaLabelRemove || 'Remove line';
        return (React.createElement("div", { className: styles.linksContainer },
            React.createElement("div", null, this.iconsMode ?
                (React.createElement(components_1.Link, { kind: "withPrependIcon", testId: utils_1.default('WRLS', 'Link', 'EditLine'), onClick: this.editItem, "aria-label": ariaLabelEdit, icon: React.createElement(components_1.IconSvg, { size: 24, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.PEN }), title: ariaLabelEdit })) :
                (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('WRLS', 'Link', 'EditLine'), onClick: this.editItem, "aria-label": ariaLabelEdit, className: CartConfiguration_scss_1.commonLinkSmall }, "Edit"))),
            !this.hideRemoveLink && React.createElement("span", { className: styles.pipeSeparator }),
            !this.hideRemoveLink && React.createElement("div", null, this.iconsMode ?
                (React.createElement(components_1.Link, { kind: "withPrependIcon", testId: utils_1.default('WRLS', 'Link', 'RemoveLine'), onClick: this.removeItem, "aria-label": ariaLabelRemove, icon: React.createElement(components_1.IconSvg, { size: 24, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.TRASH }), title: ariaLabelRemove })) :
                (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('WRLS', 'Link', 'RemoveLine'), onClick: this.removeItem, "aria-label": ariaLabelRemove, className: CartConfiguration_scss_1.commonLinkSmall }, "Remove"))),
            this.showDeleteConfirmationModal()));
    };
    EditAndRemove.prototype.editItem = function () {
        if (this.props && this.props.events && this.props.events.onItemEdit) {
            this.props.events.onItemEdit();
        }
    };
    EditAndRemove.prototype.removeItem = function () {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.showDeleteConfirmationModal) || ((_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.isFNLine)) {
            this.setState({ showDeleteModal: true });
        }
        else {
            if (this.props && this.props.events && this.props.events.onItemRemove) {
                this.props.events.onItemRemove();
            }
        }
    };
    EditAndRemove.prototype.showDeleteConfirmationModal = function () {
        var alertMsg = this.props.options.isFNLine ? this.wirelessCms.firstNetRemovalModalAlert :
            this.wirelessCms.upshellDeleteConfirmationModalAlert;
        var headerMsg = this.wirelessCms.upshellDeleteConfirmationModalHeader;
        var bodyMsg = this.wirelessCms.upshellDeleteConfirmationModalBody;
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('WRLS', 'Upsell', 'modal'), options: {
                center: true, className: { modalContentClass: styles.deleteConfirmationModal },
                show: this.state.showDeleteModal,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
            }, events: { onClose: this.onClose } },
            React.createElement("div", { className: styles.legalContainer },
                React.createElement("h3", { className: styles.deleteConfirmationTitle }, headerMsg),
                React.createElement("p", null, bodyMsg),
                React.createElement("div", { className: styles.deleteConfirmationMessage, dangerouslySetInnerHTML: { __html: alertMsg } }),
                React.createElement("div", { className: styles.deleteButtonStyle },
                    React.createElement(Button_1.default, { testId: utils_1.default('WRLS', 'Upsell', 'yes'), events: { onClick: this.onSubmit }, data: { text: 'Yes' }, options: { className: styles.deleteButton, type: ButtonProps_1.ButtonType.PRIMARY } })),
                React.createElement("div", { className: styles.deleteButtonStyle },
                    React.createElement(Button_1.default, { testId: utils_1.default('WRLS', 'Upsell', 'no'), events: { onClick: this.onClose }, data: { text: 'No' }, options: { className: styles.buttonWidth, type: ButtonProps_1.ButtonType.GHOST } })))));
    };
    EditAndRemove.prototype.onClose = function () {
        this.setState({ showDeleteModal: false });
    };
    EditAndRemove.prototype.onSubmit = function () {
        this.setState({ showDeleteModal: false });
        if (this.props && this.props.events && this.props.events.onItemRemove) {
            this.props.events.onItemRemove();
        }
    };
    return EditAndRemove;
}(React.Component));
exports.default = EditAndRemove;
//# sourceMappingURL=EditAndRemove.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/EditAndRemove/EditAndRemove.js
// module id = 2265
// module chunks = 8